import { action } from 'satcheljs';
export const setSearchDeletedItemOption = action(
    'SET_DELETED_ITEMS_IN_SEARCH_OPTION',
    (shouldExcludeDeletedItems: boolean) => ({
        shouldExcludeDeletedItems,
    })
);

export const setDefaultScopeOption = action(
    'SET_DEFAULT_SCOPE_OPTION',
    (shouldScopeToInboxFolder: boolean) => ({
        shouldScopeToInboxFolder,
    })
);

export const discardSearchResultsOptions = action('DISCARD_SEARCH_RANGE_OPTIONS');
